import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import type { WorkScope } from '@/lib/team-scope';

const SCOPES: Array<{ scope: WorkScope; label: string; to: string }> = [
  { scope: 'me', label: 'Moi', to: '/tasks' },
  { scope: 'team', label: 'Équipe', to: '/tasks?portee=equipe' },
  { scope: 'company', label: 'Entreprise', to: '/tasks?portee=entreprise' },
];

/** Managers only: the same page at a wider scope (my file, the team's week, the review of the apps). */
export const ScopeSwitch = ({ scope }: { scope: WorkScope }) => (
  <nav aria-label="Portée" className="inline-flex rounded-lg border border-domino-cardBorder bg-domino-white p-0.5">
    {SCOPES.map((item) => (
      <Link key={item.scope} to={item.to} aria-current={scope === item.scope ? 'page' : undefined}
        className={cn('rounded-md px-2.5 py-1 text-sm', scope === item.scope ? 'bg-domino-plumTint font-semibold text-domino-aubergine' : 'text-domino-inkSoft hover:text-domino-ink')}>
        {item.label}
      </Link>
    ))}
  </nav>
);
